import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SubscriptionPlan from "../common/SubscriptionPlan";
import SwoodleMobileFooter from "../../common/SwoodleMobileFooter";
import FundraiserHeader from "../common/FundraiserHeader";
import CancelSubscriptionPopup from "../../common/CancelPopup.jsx";
import {
  renewSubscription,
  cancelSubscription,
  getUserSubscription,
  getSubscriptionPlans,
   checkout
} from "../../../services/subscriptionService";
import toast from "../../../utils/toast";
import { setSelectedPlan } from "../../../redux/slices/subscriptionSlice";
import cancelImage from "../../../Assets/Images/cancelImage.svg";

export default function SwoodleHeroPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { activeSub: stateActiveSub, yearlyPlan: stateYearlyPlan } = location.state || {};

  const [activeSubLocal, setActiveSubLocal] = useState(stateActiveSub || null);
  const [yearlyPlanLocal, setYearlyPlanLocal] = useState(stateYearlyPlan || null);
  const [menuOpen, setMenuOpen] = useState(false);

  const loading = useSelector((state) => state.subscriptionReducer.loading);
  const subscriptionFromStore = useSelector((state) => state.subscriptionReducer.subscription);

  useEffect(() => {
    if (!activeSubLocal && subscriptionFromStore) {
      setActiveSubLocal(subscriptionFromStore);
    }
  }, [subscriptionFromStore, activeSubLocal]);

  useEffect(() => {
    const fetchMissing = async () => {
      try {
        if (!yearlyPlanLocal) {
          const plansResp = await dispatch(getSubscriptionPlans({})).unwrap();
          const plans = plansResp?.data || [];
          const pickYearly =
            plans.find((p) => String(p?.duration || "").toLowerCase().includes("year")) ||
            plans[0] ||
            null;
          setYearlyPlanLocal(pickYearly);
        }
      } catch {}

      try {
        if (!activeSubLocal) {
          const subResp = await dispatch(getUserSubscription()).unwrap();
          const sub = Array.isArray(subResp?.data) && subResp.data.length > 0 ? subResp.data[0] : null;
          setActiveSubLocal(sub);
        }
      } catch {}
    };

    fetchMissing();
  }, []);

  const subscriptionId = activeSubLocal?.subscriptionId || subscriptionFromStore?.subscriptionId || null;

  const hasActiveSubscription = activeSubLocal?.status === "active";
  const isExpired = activeSubLocal?.status === "expired";

  const [cancelClicked, setCancelClicked] = useState(false);

const handleJoinNow = async () => {
  try {
    dispatch(setSelectedPlan(yearlyPlanLocal));

    const status = activeSubLocal?.status; 
    if (!status) {
      const checkoutPayload = { priceId: yearlyPlanLocal?.priceId };
      const checkoutResult = await dispatch(checkout(checkoutPayload)).unwrap();
      if (checkoutResult?.success && checkoutResult?.data?.url) {
        window.location.href = checkoutResult.data.url;
        return;
      }
    }
    if (status === "expired" || status === "cancelled") {
      const renewPayload = { priceId: yearlyPlanLocal?.priceId };
      const renewResult = await dispatch(renewSubscription(renewPayload)).unwrap();
      if (renewResult?.success && renewResult?.data?.url) {
        window.location.href = renewResult.data.url;
        return;
      }
    }
    dispatch(getUserSubscription());
  } catch {
    toast.error("Something went wrong during subscription.");
  }
};
  const cancelClick = () => setCancelClicked(true);
  const handleKeepPlan = () => setCancelClicked(false);

  const handleCancelSub = async () => {
  setCancelClicked(false);

  if (!subscriptionId) {
    toast.error("No active subscription found to cancel.");
    return;
  }

  try {
    const cancelResult = await dispatch(cancelSubscription({ subscriptionId })).unwrap();
    if (cancelResult?.success) {
      toast.success("Subscription cancelled successfully!");
      await dispatch(getUserSubscription()); 
  
       try {
      dispatch(setSelectedPlan(yearlyPlanLocal));
      const renewPayload = { priceId: yearlyPlanLocal?.priceId };
      const renewResult = await dispatch(renewSubscription(renewPayload)).unwrap();

      if (renewResult?.success && renewResult?.data?.url) {
        window.location.href = renewResult.data.url;
      } else {
        toast.success("Subscription renewed successfully!");
        dispatch(getUserSubscription());
      }
    } catch (error) {
      console.error("Renewal failed:", error);
      toast.error("Something went wrong during subscription.");
      navigate("/fundraiser-subscription");
    }
    } else {
      toast.error("Failed to cancel subscription. Please try again.");
    }
  } catch (err) {
    console.error("Cancel failed:", err);
    toast.error("Failed to cancel subscription.");
  }
};


  return (
    <>
      <div className="bg-white text-gray-800">
        <header className="w-full bg-[#002147] text-white px-6 py-4 flex items-center justify-between rounded-b-3xl relative z-[100]">
          <FundraiserHeader />

          {/* <nav className="hidden md:flex gap-8 text-sm font-medium">
            <a href="#" className="hover:text-yellow-400">Members</a>
            <a href="#" className="hover:text-yellow-400">Merchants</a>
            <a href="#" className="hover:text-yellow-400">Fundraisers</a>
            <a href="#" className="hover:text-yellow-400">Contact Us</a>
          </nav> */}
{/* 
          <div className="hidden md:flex gap-3">
            {loading ? null : hasActiveSubscription ? (
              <button onClick={cancelClick} className="bg-red-500 text-white rounded-full px-5 py-2 text-sm font-semibold">
                Cancel Subscription
              </button>
            ) : isExpired ? (
              <button onClick={handleJoinNow} className="bg-yellow-400 text-black rounded-full px-5 py-2 text-sm font-semibold">
                Renew Subscription
              </button>
            ) : (
              <button onClick={handleJoinNow} className="bg-yellow-400 text-black rounded-full px-5 py-2 text-sm font-semibold">
                Join Now
              </button>
            )}
          </div> */}

          {/* <button className="md:hidden text-yellow-300 text-2xl" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button> */}
        </header>
        {/* {menuOpen && (
          <div className="md:hidden bg-[#002147] text-white px-6 py-4 space-y-4 shadow-lg rounded-b-3xl">
            <a href="#" className="block text-sm font-medium hover:text-yellow-400">Members</a>
            <a href="#" className="block text-sm font-medium hover:text-yellow-400">Merchants</a>
            <a href="#" className="block text-sm font-medium hover:text-yellow-400">Fundraisers</a>
            <a href="#" className="block text-sm font-medium hover:text-yellow-400">Contact Us</a>

            {loading ? null : hasActiveSubscription ? (
              <button onClick={cancelClick} className="w-full bg-red-500 text-white rounded-full px-5 py-2 text-sm font-semibold">
                Cancel Subscription
              </button>
            ) : isExpired ? (
              <button onClick={handleJoinNow} className="w-full bg-yellow-400 text-black rounded-full px-5 py-2 text-sm font-semibold">
                Renew Subscription
              </button>
            ) : (
              <button onClick={handleJoinNow} className="w-full bg-yellow-400 text-black rounded-full px-5 py-2 text-sm font-semibold">
                Join Now
              </button>
            )}
          </div>
        )} */}

        <section
          className="w-full mt-8 rounded-3xl overflow-hidden relative bg-center bg-cover flex items-center justify-center text-center px-6 py-24 md:py-32"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?auto=format&fit=crop&w=1567&q=80')",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>

          <div className="relative max-w-3xl text-white drop-shadow-lg z-10">
            <h1 className="text-3xl md:text-5xl font-semibold leading-tight">
              <span className="text-yellow-300">Save Big.</span> Do Good. Feel Great.
            </h1>
            <p className="text-base md:text-xl mt-4 font-light px-2">
              40% of your membership supports the cause you choose.
            </p>
          </div>
        </section>
      </div>

      {cancelClicked && (
        <CancelSubscriptionPopup
          handleNo={handleKeepPlan}
          handleYes={handleCancelSub}
          heading={"Cancel Subscription"}
          content={"Are you sure you want to cancel subscription?"}
          image={cancelImage}
        />
      )}

      <section className="mx-auto text-center px-6 py-12 md:py-16 mt-8">
        <h2 className="text-2xl md:text-3xl font-semibold text-[#002147] mb-4">
          Why Join Swoodle?
        </h2>
        <p className="text-gray-700 text-base md:text-lg leading-relaxed">
          Swoodle membership unlocks exclusive savings at thousands of local
          businesses, while helping support meaningful causes in your community.
        </p>
      </section>

      <div className="flex flex-wrap justify-center gap-6 px-6 py-10 bg-[#F4F4F4]">
        {yearlyPlanLocal && (
          <SubscriptionPlan
            title={yearlyPlanLocal.name}
            plans={yearlyPlanLocal.description?.split(",")}
            price={yearlyPlanLocal.amount}
            duration={yearlyPlanLocal.duration}
            joinClick={handleJoinNow}
            cancelOption={hasActiveSubscription}
            cancelClick={cancelClick}
          />
        )}
      </div>

      <SwoodleMobileFooter />
    </>
  );
}
